import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface SaveButtonProps {
  onClick?: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  label?: string;
  loadingLabel?: string;
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'warning' | 'info';
}

export default function FormEditorSaveButton({
  onClick,
  disabled,
  isLoading,
  label,
  loadingLabel,
  color,
}: SaveButtonProps) {
  const { t } = useTranslation();
  return (
    <Button
      color={color ?? 'primary'}
      variant="contained"
      disabled={disabled || isLoading}
      onClick={onClick}
      sx={{
        ml: 1,
        maxHeight: '36.5px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {isLoading
        ? loadingLabel ?? t('general.isSaving')
        : label ?? t('general.save')}
    </Button>
  );
}
